/**
 * Demo Mode Configuration
 * Controls whether the app runs in demo mode with mock data or production mode with real APIs
 */

export const DEMO_CONFIG = {
  // Set to true for demo mode, false for production
  IS_DEMO_MODE: true,
  
  // Demo mode settings
  DEMO: {
    // Simulate API delays
    API_DELAY_MS: 1000,
    
    // Mock data settings
    MOCK_USER_ID: 'demo-user-123',
    MOCK_WORKOUT_ID: 'demo-workout-456',
    
    // Demo-specific features
    ENABLE_DEBUG_LOGGING: true,
    SHOW_DEMO_BANNER: true,
  },
  
  // Production API endpoints
  PRODUCTION: {
    API_BASE_URL: import.meta.env.VITE_API_BASE_URL || 'https://api.sculptd.com',
    HEALTH_DATA_ENDPOINT: '/api/health-data',
    WORKOUTS_ENDPOINT: '/api/workouts',
    EXERCISES_ENDPOINT: '/api/exercises',
    COMMUNITY_ENDPOINT: '/api/community',
    USER_PROFILE_ENDPOINT: '/api/user/profile',
  }
};

/**
 * Check if app is running in demo mode
 */
export const isDemoMode = (): boolean => {
  return DEMO_CONFIG.IS_DEMO_MODE;
};

/**
 * Get API base URL based on mode
 */
export const getApiBaseUrl = (): string => {
  return isDemoMode() ? 'demo' : DEMO_CONFIG.PRODUCTION.API_BASE_URL;
};

/**
 * Simulate API delay in demo mode
 */
export const simulateApiDelay = async (): Promise<void> => {
  if (isDemoMode()) {
    await new Promise(resolve => setTimeout(resolve, DEMO_CONFIG.DEMO.API_DELAY_MS));
  }
};

/**
 * Log demo mode actions
 */
export const logDemoAction = (action: string, data?: any): void => {
  if (isDemoMode() && DEMO_CONFIG.DEMO.ENABLE_DEBUG_LOGGING) {
    console.log(`[DEMO] ${action}`, data);
  }
};
